import { Component, h, Host, State } from '@stencil/core';
import store from '../store';

@Component({
  tag: 'ui-download-search-sort',
  styleUrl: 'ui-download-search-sort.scss',
  shadow: false,
})
export class UiDownloadSearchSort {
  @State() sortingOptions = [];

  setSortingOptions = () => {
    this.sortingOptions = store.state.fundsMode
      ? [
          { label: 'Titel aufsteigend', value: 'title:ASC' },
          { label: 'Titel absteigend', value: 'title :DESC' },
        ]
      : [
          { label: 'Relevanz', value: 'result.ranking:DESC' },
          { label: 'Datum absteigend', value: 'date:DESC' },
          { label: 'Datum aufsteigend', value: 'date:ASC' },
          { label: 'Titel absteigend', value: 'title:DESC' },
          { label: 'Titel aufsteigend', value: 'title:ASC' },
        ];
  };

  componentWillLoad() {
    this.setSortingOptions();
    store.onChange('fundsMode', () => {
      this.setSortingOptions();
      store.state.sorting = this.sortingOptions[0].value;
    });
  }

  private onSortChange(event: CustomEvent<{ value: string }>) {
    store.state.tracking.trackAction(
      'DownloadSearchSortChange',
      this.sortingOptions.find((option) => option.value === event.detail.value)
        .label
    );
    store.state.sorting = event.detail.value;
  }

  private onRadioCheck(selectedSort: string, event: InputEvent) {
    if ((event.target as HTMLInputElement).checked) {
      store.state.sorting = selectedSort;
    }
  }

  private renderDesktopSorter = () => (
    <div class="search-sort__wrapper">
      <span class="search-sort__label"> Sortieren nach</span>
      <ui-select
        class="search-sort__filter"
        key={`fundsMode_${store.state.fundsMode}`}
        onChange={this.onSortChange.bind(this)}
      >
        {this.sortingOptions.map((el) => (
          <option
            key={el.value}
            value={el.value}
            selected={el.value === store.state.sorting}
          >
            {el.label}
          </option>
        ))}
      </ui-select>
    </div>
  );

  private renderMobileSorter = () => (
    <div>
      <ui-offcanvas-trigger offcanvas-id="filterSort">
        <ui-button class="search-sort__button">Sortieren</ui-button>
      </ui-offcanvas-trigger>
      <ui-offcanvas-panel id="filterSort" darken close-outside>
        <div class="search-sort-panel__wrapper">
          <ui-offcanvas-trigger offcanvas-id="filterSort">
            <ui-button
              class="search-sort-panel__link"
              variant="plain"
              icon={'close'}
            >
              Sortierung schließen
            </ui-button>
          </ui-offcanvas-trigger>
          <ui-headline class="search-sort-panel__headline" level={3}>
            Sortieren nach
          </ui-headline>
          <ui-fieldset>
            {this.sortingOptions.map((el) => (
              <ui-input
                onChange={(event: InputEvent) =>
                  this.onRadioCheck(el.value, event)
                }
                class="search-sort-panel__radio"
                type="radio"
                name={el.label}
                key={el.value}
                value={el.value}
                label={el.label}
                checked={el.value === store.state.sorting}
              ></ui-input>
            ))}
          </ui-fieldset>
          <ui-offcanvas-trigger offcanvas-id="filterSort">
            <ui-button class="search-sort-panel__button">
              Sortierung anwenden
            </ui-button>
          </ui-offcanvas-trigger>
        </div>
      </ui-offcanvas-panel>
    </div>
  );

  render() {
    return (
      <Host class="search-sort">
        {!store.state.isMobile &&
          store.state.results.length > 0 &&
          this.renderDesktopSorter()}
        {store.state.isMobile &&
          store.state.results.length > 0 &&
          this.renderMobileSorter()}
      </Host>
    );
  }
}
